import axios from 'axios';
import api from './api';

export default {
  state: {
    platforms: [],
    games: [],
    myPlatforms: [],
    myGames: [],
    myRecommendations: null,
    history: [],
    killList: [],
    me: null,
    playerId: parseInt(localStorage.getItem('player_id'), 10),
    token: localStorage.getItem('token'),
  },
  actions: {
    async fetchPlatforms(context) {
      return axios.get(`${api.endpoint}/platforms`).then(response => context.commit('fetchPlatforms', response.data));
    },
    async fetchGames(context) {
      return axios.get(`${api.endpoint}/games`).then(response => context.commit('fetchGames', response.data));
    },
    async fetchMyPlatforms(context) {
      return axios
        .get(`${api.endpoint}/players/${context.state.playerId}/platforms`)
        .then(response => context.commit('fetchMyPlatforms', response.data));
    },
    async fetchMe(context) {
      return axios
        .get(`${api.endpoint}/me`, {
          headers: {
            'X-Player-Id': context.state.playerId,
            'X-Token': context.state.token,
          },
        })
        .then(response => context.commit('fetchMe', response.data));
    },
    async fetchMyGames(context) {
      return axios
        .get(`${api.endpoint}/players/${context.state.playerId}/games`)
        .then(response => context.commit('fetchMyGames', response.data));
    },
    async fetchMyRecommendations(context) {
      return axios
        .get(`${api.endpoint}/players/${context.state.playerId}/recommendations`)
        .then(response => context.commit('fetchMyRecommendations', response.data));
    },
    async fetchHistory(context) {
      return axios
        .get(`${api.endpoint}/players/${context.state.playerId}/scores`)
        .then(response => context.commit('fetchHistory', response.data));
    },
    async fetchKillList(context) {
      return axios
        .get(`${api.endpoint}/players/${context.state.playerId}/kill-list`)
        .then(response => context.commit('fetchKillList', response.data));
    },
    async setPlayerId({ commit }, playerId) {
      commit('setPlayerId', playerId);
    },
  },

  mutations: {
    setPlayerId(state, playerId) {
      localStorage.setItem('player_id', playerId.toString());
      state.playerId = playerId;
    },
    setToken(state, token) {
      localStorage.setItem('token', token);
      state.token = token;
    },
    fetchPlatforms(state, platforms) {
      state.platforms = platforms;
    },
    fetchGames(state, games) {
      state.games = games;
    },
    fetchMyPlatforms(state, myPlatforms) {
      state.myPlatforms = myPlatforms;
    },
    fetchMe(state, me) {
      state.me = me;
    },
    fetchMyGames(state, myGames) {
      state.myGames = myGames;
    },
    fetchMyRecommendations(state, myRecommendations) {
      state.myRecommendations = myRecommendations;
    },
    fetchHistory(state, history) {
      state.history = history;
    },
    fetchKillList(state, killList) {
      state.killList = killList;
    },
  },
  getters: {
    platforms(state) {
      return state.platforms;
    },
    games(state) {
      return state.games;
    },
    myPlatforms(state) {
      return state.myPlatforms;
    },
    myGames(state) {
      return state.myGames;
    },
    myRecommendations(state) {
      return state.myRecommendations;
    },
    history(state) {
      return state.history;
    },
    killList(state) {
      return state.killList;
    },
  },
};
